import axios from "axios"

import { baseApiUrl } from "../General/Constants"

import localStorageProvider from "../Providers/LocalStorageProvider"

export default () => {
  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response.status === 401) {
        localStorageProvider.removeItem("token")
        localStorageProvider.removeItem("user")
      }
      return error
    }
  )

  return {
    getList: (resource: any, params: any) => {
      const { page, perPage } = params.pagination
      const { field, order } = params.sort

      const url = `${baseApiUrl}/customer/private/${resource}/listPaginated?page=${page}&perPage=${perPage}&sortBy=${field}&sort=${order}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.get(url, auth).then(({ data }) => ({
        data: data?.data,
        total: data?.total,
      }))
    },

    getOne: (resource: any, params: any) => {
      const { id } = params

      const url =
        id === undefined || id === null
          ? `${baseApiUrl}/customer/private/${resource}/single`
          : `${baseApiUrl}/customer/private/${resource}/single?id=${id}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.get(url, auth).then(({ data }) => ({
        data: data,
      }))
    },

    getMany: (resource: any, params: any) => {
      const { ids } = params

      const url = `${baseApiUrl}/customer/private/${resource}/many?ids=${ids.join(
        ","
      )}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.get(url, auth).then(({ data }) => ({
        data: data,
      }))
    },

    getManyReference: (resource: any, params: any) => {
      const url = `${baseApiUrl}/customer/private/${resource}/single?${params
        .map((i) => `id=${i}`)
        .join(",")}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.get(url, auth).then(({ data }) => ({
        data: data,
      }))
    },

    getStatistics: (resource: any, params: any) => {
      const url = `${baseApiUrl}/customer/private/statistics/${resource}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.post(url, params, auth).then(({ data }) => ({
        data: data,
      }))
    },

    update: (resource: any, params: any) => {
      const url = `${baseApiUrl}/customer/private/${resource}/update?id=${params.id}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      delete params.data.id

      return axios.post(url, params.data, auth).then(({ data }) => ({ data }))
    },

    updateMany: (resource: any, params: any) => Promise.resolve(),

    create: (resource: any, params: any) => {
      const url = `${baseApiUrl}/customer/private/${resource}/create`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.post(url, params.data, auth).then(({ data }) => ({ data }))
    },

    delete: (resource: any, params: any) => {
      const url = `${baseApiUrl}/customer/private/${resource}/delete?id=${params.id}`
      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.delete(url, auth).then(({ data }) => ({ data }))
    },

    deleteMany: (resource: any, params: any) => {
      const { ids } = params

      const url = `${baseApiUrl}/customer/private/${resource}/deleteMany?ids=${ids.join(
        ","
      )}`

      const token = localStorageProvider.getItem("token")
      const auth = { headers: { Authorization: `Bearer ${token}` } }

      return axios.get(url, auth).then(({ data }) => ({
        data: data,
      }))
    },
  }
}
